'use client';

import { c as _c } from "react/compiler-runtime";
import { vaultIncludesDonations } from '@/config/donation-vaults';
import { isVaultV2RateCapped } from '@/helpers/vaultV2RateCap';
import { useVaultV2Apy } from '@/hooks/useVaultV2Apy';
import type { VaultV2PerformanceData } from './VaultV2Performance.mapper';
import { sortPendingTimelocks } from '../VaultV2PendingTimelock/utils';
import { VaultV2PerformanceFees, VaultV2PerformanceLayout, VaultV2PerformanceReturns } from './components';
interface VaultV2PerformanceClientProps {
  performance: VaultV2PerformanceData;
}
const VaultV2PerformanceClient = t0 => {
  const $ = _c(50);
  const {
    performance
  } = t0;
  let t1;
  if ($[0] !== performance.address || $[1] !== performance.apyBreakdown || $[2] !== performance.asset || $[3] !== performance.managementFee || $[4] !== performance.maxRate || $[5] !== performance.netApy || $[6] !== performance.netApyExcludingRewards || $[7] !== performance.performanceFee || $[8] !== performance.rewards) {
    t1 = {
      vaultV2: {
        address: performance.address,
        asset: performance.asset,
        performanceFee: performance.performanceFee,
        managementFee: performance.managementFee,
        netApyExcludingRewards: performance.netApyExcludingRewards,
        netApy: performance.netApy,
        apyBreakdown: performance.apyBreakdown,
        maxRate: performance.maxRate,
        rewards: performance.rewards
      }
    };
    $[0] = performance.address;
    $[1] = performance.apyBreakdown;
    $[2] = performance.asset;
    $[3] = performance.managementFee;
    $[4] = performance.maxRate;
    $[5] = performance.netApy;
    $[6] = performance.netApyExcludingRewards;
    $[7] = performance.performanceFee;
    $[8] = performance.rewards;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const {
    apy,
    netApy,
    performanceFee: performanceFeeBigInt,
    managementFee: managementFeeBigInt,
    maxRate,
    points,
    rewards
  } = useVaultV2Apy(t1);
  let t2;
  if ($[10] !== performance.grossApy || $[11] !== performance.maxApy) {
    t2 = isVaultV2RateCapped(performance.grossApy, performance.maxApy);
    $[10] = performance.grossApy;
    $[11] = performance.maxApy;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const isRateCapped = t2;
  let t3;
  if ($[13] !== performance.address || $[14] !== performance.chainId) {
    t3 = vaultIncludesDonations(performance.chainId, performance.address);
    $[13] = performance.address;
    $[14] = performance.chainId;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const includesDonations = t3;
  let t4;
  if ($[16] !== performance.pendingConfigs) {
    t4 = performance.pendingConfigs ?? [];
    $[16] = performance.pendingConfigs;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t4) {
    t5 = sortPendingTimelocks(t4);
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const sortedPendingTimelocks = t5;
  let t6;
  if ($[20] !== performance.performanceFee || $[21] !== performance.performanceFeeRecipient) {
    t6 = {
      fee: performance.performanceFee,
      recipient: performance.performanceFeeRecipient
    };
    $[20] = performance.performanceFee;
    $[21] = performance.performanceFeeRecipient;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const performanceFeeData = t6;
  let t7;
  if ($[23] !== performance.managementFee || $[24] !== performance.managementFeeRecipient) {
    t7 = {
      fee: performance.managementFee,
      recipient: performance.managementFeeRecipient
    };
    $[23] = performance.managementFee;
    $[24] = performance.managementFeeRecipient;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const managementFeeData = t7;
  let t8;
  if ($[26] !== apy || $[27] !== includesDonations || $[28] !== isRateCapped || $[29] !== managementFeeBigInt || $[30] !== maxRate || $[31] !== netApy || $[32] !== performance.apyBreakdown || $[33] !== performance.asset || $[34] !== performance.maxApy || $[35] !== performance.monthlyAvgNetApy || $[36] !== performance.quarterlyAvgNetApy || $[37] !== performance.weeklyAvgNetApy || $[38] !== performanceFeeBigInt || $[39] !== points || $[40] !== rewards) {
    t8 = <VaultV2PerformanceReturns instantApy={netApy} apy={apy} performanceFee={performanceFeeBigInt} managementFee={managementFeeBigInt} maxRate={maxRate} apyBreakdown={performance.apyBreakdown} maxApy={performance.maxApy} isRateCapped={isRateCapped} includesDonations={includesDonations} rewards={rewards} points={points} asset={performance.asset} apy7d={performance.weeklyAvgNetApy} apy30d={performance.monthlyAvgNetApy} apy90d={performance.quarterlyAvgNetApy} />;
    $[26] = apy;
    $[27] = includesDonations;
    $[28] = isRateCapped;
    $[29] = managementFeeBigInt;
    $[30] = maxRate;
    $[31] = netApy;
    $[32] = performance.apyBreakdown;
    $[33] = performance.asset;
    $[34] = performance.maxApy;
    $[35] = performance.monthlyAvgNetApy;
    $[36] = performance.quarterlyAvgNetApy;
    $[37] = performance.weeklyAvgNetApy;
    $[38] = performanceFeeBigInt;
    $[39] = points;
    $[40] = rewards;
    $[41] = t8;
  } else {
    t8 = $[41];
  }
  let t9;
  if ($[42] !== managementFeeData || $[43] !== performance.chainId || $[44] !== performanceFeeData || $[45] !== sortedPendingTimelocks) {
    t9 = <VaultV2PerformanceFees chainId={performance.chainId} performanceFeeData={performanceFeeData} managementFeeData={managementFeeData} pendingTimelocks={sortedPendingTimelocks} />;
    $[42] = managementFeeData;
    $[43] = performance.chainId;
    $[44] = performanceFeeData;
    $[45] = sortedPendingTimelocks;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  if ($[47] !== t8 || $[48] !== t9) {
    t10 = <VaultV2PerformanceLayout>{t8}{t9}</VaultV2PerformanceLayout>;
    $[47] = t8;
    $[48] = t9;
    $[49] = t10;
  } else {
    t10 = $[49];
  }
  return t10;
};
export default VaultV2PerformanceClient;